import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const TRIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TR" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          d="M7.875 2.042c.926-.001 2.057.539 2.382 1.307 0 0-1.037-.598-2.214-.316-1.176.281-1.92 1.32-1.93 2.55-.01 1.314.83 2.21 1.9 2.474 1.064.262 2.185-.355 2.199-.363-.138.407-.802 1.364-2.201 1.367-1.746.003-3.731-1.26-3.715-3.478.016-2.139 1.854-3.537 3.579-3.54Zm3.33 2.88 1.11-.375-.682.953 1.038.892-1.31-.095-.793.951.02-1.268-1.204-.424 1.068-.393-.04-1.124.793.882Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
